// Single source of truth for "which module is this URL?".
//
// Lived inline in Layout.js, where only the module-visit ping could reach it.
// The error tracker in utils/trackAction.js needs the same answer ("which
// screen was the agent on when this broke?") and importing a 3,900-line layout
// component to get a lookup table would be both a cycle and a lot of weight —
// so the table moved here and Layout imports it like everyone else. One copy:
// a second one would drift the first time a module is added.

export const PATHNAME_TO_MODULE = {
  '/': 'dashboard',
  '/monitor': 'monitor', '/sonos': 'monitor', '/remote-access': 'remote_access', '/remote-assist': 'remote_access', '/llamadas': 'voice_calls', '/live-assist-pro': 'live_assist_pro',
  '/cctv': 'cctv', '/video-wall': 'video_wall', '/site-content': 'site_content', '/web-review': 'web_review', '/it-costs': 'it_costs', '/offboarding': 'offboarding', '/website-reports': 'website_reports', '/cockpit': 'cockpit', '/campaigns': 'campaigns', '/data-integrity': 'data_integrity', '/api-tokens': 'api_tokens', '/smart-homes': 'smart_homes', '/portal-studio': 'portal_studio', '/wa-avatars': 'wa_avatars', '/2fa-codes': '2fa_codes', '/agents': 'agents', '/game-admin': 'game_admin', '/game': 'game', '/prode': 'prode',
  '/announcements': 'announcements', '/attendance': 'attendance',
  '/team': 'team_panel',
  '/agent-status': 'agent_status', '/agent-activity': 'agent_activity', '/usage-hotspots': 'usage_hotspots', '/worker-health': 'worker_health',
  '/agent-dashboards': 'agent_dashboards',
  '/system-activity': 'system_activity',
  '/hr': 'hr', '/my-payroll': 'my_payroll',
  '/chat': 'chat', '/kb': 'knowledge_base', '/rag-search': 'rag_search', '/budgets': 'budgets',
  '/vault': 'vault', '/email-accounts': 'email_accounts',
  '/calendar': 'calendar', '/comms-monitor': 'comms_monitor',
  '/whatsapp-settings': 'whatsapp', '/deployments': 'deployments', '/projects': 'projects', '/topology': 'topology',
  '/resource-monitor': 'resource_monitor',
  '/backup-monitor': 'backup_monitor', '/ops-monitor': 'ops_monitor', '/vps-health': 'vps_health', '/dmarc': 'dmarc', '/cloud-costs': 'cloud_costs', '/tool-costs': 'tool_costs', '/costs': 'costs_hub', '/ip-intelligence': 'ip_intel', '/configurations': 'configurations',
  '/vpn': 'vpn',
  '/audit-log': 'audit_log', '/agent-ratings': 'agent_ratings', '/settings': 'settings',
  '/tickets/review-queue': 'review_queue', '/tickets': 'tickets', '/supplies': 'supplies', '/invoicing': 'invoicing',
  '/accounts': 'customer_accounts',
  '/companies': 'companies', '/client-access': 'client_access',
  '/ticket-import': 'ticket_import',
  '/storage': 'storage',
  '/field-tasks': 'errands', '/requests': 'requests', '/report-review': 'report_review',
  '/reports': 'reports',
  '/diagnostics': 'diagnostics',
  '/assets': 'assets',
  '/workshop': 'workshop',
  '/prepaid-lines': 'prepaid_lines',
  '/racks': 'racks',
  '/google-business': 'google_business',
  '/legacy-sheets': 'legacy_sheets',
  '/mercadolibre': 'mercadolibre',
  '/quick-launch': 'quick_launch',
  '/access-control': 'access_control',
  '/file-permissions': 'file_permissions',
  '/monitoring': 'monitoring',
  '/feedback': 'feedback_requests',
  '/changelog': 'changelog',
  '/personnel': 'personnel',
  '/notifications': 'tickets',
  '/tickets-private': 'tickets',
  '/inbound-rules': 'inbound_rules',
  '/ai-dashboard': 'ai_dashboard',
  '/growth': 'growth',
  '/telegram-routes': 'telegram_routes',
  '/procedures': 'procedures',
  '/provisioning': 'provisioning',
  '/agent-actions': 'agent_actions',
  '/portal-permissions': 'portal_permissions',
};
export const TRACKED_MODULES = new Set(Object.values(PATHNAME_TO_MODULE));

// Longest-prefix match, so '/monitoring/settings' resolves to `monitoring`
// rather than falling through. '/' only matches the bare root.
export function moduleFromPath(pathname) {
  if (!pathname) return null;
  let best = null;
  for (const [prefix, key] of Object.entries(PATHNAME_TO_MODULE)) {
    if (prefix === '/') {
      if (pathname === '/') return key;
      continue;
    }
    if (pathname === prefix || pathname.startsWith(prefix + '/')) {
      if (!best || prefix.length > best.prefix.length) best = { prefix, key };
    }
  }
  return best ? best.key : null;
}
